"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @author Sean sean.snow@live.com
 * @date 2015/12/27
 */

var Integer = function Integer() {
  _classCallCheck(this, Integer);
};

Integer.MAX_VALUE = 0x7fffffff;
exports.default = Integer;


//////////////////
// WEBPACK FOOTER
// ./node_modules/jsdk/lang/Integer.js
// module id = 33
// module chunks = 0